<template>
  <div>
    <div v-for="feature in features" :key="'feature-' + feature.name" class="mb-3">
      <div class="row responsive-feature-card">
        <div class="col-24 col-md-3 d-flex align-items-center responsive-toggler">
          <Toggler
            @input="toggleFeatureEnabled(feature.name)"
            :active="feature.enabled"
            :disabled="feature.required"
            :style="{ opacity: feature.required ? 0.5 : 1 }"
            field-name=""
          />
          <span class="text-muted font-weight-bold responsive-toggle-label">{{
            feature.enabled ? translations.feature_enabled : translations.feature_disabled
          }}</span>
        </div>
        <div class="col-24 col-md-21">
          <div class="">
            <span class="font-weight-bold">{{ feature.name }}</span>
            <span
              v-if="feature.browser_storage_entries.length"
              :ref="'toggleFeatureDetails-' + feature.name"
              @click="toggleFeatureDetails(feature.name)"
              class="ml-2 text-muted text-sm cursor-pointer"
              >({{
                showFeatureDetails[feature.name]
                  ? translations.hide_details
                  : translations.show_details
              }})</span
            >
          </div>
          <p class="mb-0">{{ feature.description }}</p>
          <div v-if="showFeatureDetails[feature.name] && feature.browser_storage_entries.length">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <td>{{ translations.entry_name }}</td>
                    <td>{{ translations.provider }}</td>
                    <td>{{ translations.purpose }}</td>
                    <td>{{ translations.expiration }}</td>
                    <td>{{ translations.type }}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="entry in feature.browser_storage_entries"
                    :key="'entry-' + entry.identifier"
                  >
                    <td>{{ entry.identifier }}</td>
                    <td>{{ entry.provider }}</td>
                    <td>{{ entry.purpose }}</td>
                    <td>{{ entry.expiration }}</td>
                    <td>{{ entry.storage_type }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end responsive-consent-buttons">
      <button
        ref="consentButtonRequired"
        @click="buttonClicked('required')"
        class="btn btn-sm btn-secondary-subtle"
      >
        {{ translations.accept_required }}
      </button>
      <button
        ref="consentButtonAll"
        @click="buttonClicked('all')"
        class="ml-2 btn btn-sm btn-success"
      >
        {{ translations.accept_all }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Toggler from "./Toggler";

export default {
  name: "FeatureTable",
  components: { Toggler },
  props: {
    translations: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      showFeatureDetails: {},
    };
  },
  computed: {
    ...mapGetters({
      features: "features/features",
    }),
  },
  methods: {
    ...mapActions({
      toggleFeatureEnabled: "features/toggleFeatureEnabled",
      consentGiven: "features/consentGiven",
      hideModal: "hideModal",
      setFeaturesFilter: "features/setFeaturesFilter",
    }),
    toggleFeatureDetails(featureName) {
      this.showFeatureDetails = {
        ...this.showFeatureDetails,
        [featureName]: !this.showFeatureDetails[featureName],
      };
    },
    buttonClicked(consent) {
      this.consentGiven(consent);
      this.setFeaturesFilter("");
      this.hideModal("featureTable");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.responsive-feature-card {
  flex-direction: column-reverse;

  @media (min-width: $screen-md-min) {
    flex-direction: row;
  }

  .responsive-toggler {
    flex-direction: row;
    margin-top: $spacer-2;

    @media (min-width: $screen-md-min) {
      margin-top: 0;
      flex-direction: column;
    }

    .responsive-toggle-label {
      margin-left: $spacer-2;

      @media (min-width: $screen-md-min) {
        margin-left: 0;
      }
    }
  }
}

.responsive-consent-buttons {
  @media (max-width: $screen-md-min) {
    flex-direction: column;

    button {
      width: 100%;
      /* stylelint-disable-next-line declaration-no-important */
      margin-left: 0 !important;
      margin-top: $spacer-2;
    }
  }
}
</style>
